import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Table } from '../../../../common/Table';
import { numberFormatter } from '../../../../../utils/number';
import DateCell from '../../../../common/cells/DateCell';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';

const DepositBankAccounResource = ({ depositBankAccountList }) => {
  // ✅ Si no hay datos, no muestra nada
  if (!depositBankAccountList || depositBankAccountList.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <h3>Operaciones en Cuenta Bancarias</h3>
      <Table
        columns={[
          {
            Header: 'Fecha de Depósito',
            accessor: 'depositDate',
            className: 'text-center',
            Cell: (row) => (
              <DateCell format={DATE_TIME_FORMAT} value={row.value} />
            ),
          },
          {
            Header: 'Banco',
            accessor: 'bankAccount.bank.name',
            className: 'text-center',
          },
          {
            Header: 'Número de Cuenta',
            accessor: 'bankAccount',
            className: 'text-center',
            Cell: (row) => {
              const accountNumber =
                row.original.bankAccount.accountNumber || '';
              const interbankNumber =
                row.original.bankAccount.interbankNumber || '';
              return `${accountNumber} - CCI: ${interbankNumber}`.trim();
            },
          },
          {
            Header: 'Número de Operación',
            accessor: 'operationNumber',
            className: 'text-center',
          },
          {
            Header: 'Monto',
            accessor: 'actualAmountDeposited',
            Cell: ({ value }) => numberFormatter({ value }),
            className: 'text-center',
          },

          {
            Header: 'Operador',
            accessor: 'operatorUser.customer.fullName',
            className: 'text-center',
          },
        ]}
        data={depositBankAccountList}
        defaultPageSize={depositBankAccountList.length}
        showPagination={false}
      />
      <br />
    </Fragment>
  );
};

DepositBankAccounResource.propTypes = {
  depositBankAccountList: PropTypes.arrayOf(
    PropTypes.shape({
      bankAccount: PropTypes.shape({
        accountNumber: PropTypes.string,
        bank: PropTypes.shape({ name: PropTypes.string }),
      }),
      operationNumber: PropTypes.number,
      actualAmountDeposited: PropTypes.number,
    }),
  ).isRequired,
};

export default DepositBankAccounResource;
